// LocContext.ERROR
// prettier-ignore
export default {
  // localization/translateErrorMessageFromBackend.ts
  "e2ffd0333fad": "Testfeil {0}. Enda en interpolert verdi: {1}",
  "0d2b0c506e7d": "Timelisten er allerede eksportert",
  "761d595b0b4d": "Ugyldig eller utløpt token",
  "2948f8d24df0": "Denne profilen er allerede tilkoblet.",
  "0339a3c3141e": "En profil er allerede tilkoblet for {0}.",
  "fbd6eee858a4": "En eller flere obligatoriske parametre er ubalansert",
  "13179558cc52": "Uautorisert - ingen next token",
  "76c44cb117da": "Mangler konsern ID",
  "5f05708fbc5a": "Intern operasjon",
}